import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Container, TextField, FormGroup, FormControl, Button, RadioGroup, FormControlLabel, Radio, Checkbox, Modal } from '@mui/material';
import "./App.css";
import { saveElementPdf } from './common/saveElementPdf';
import api from './api';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { createRoot } from "react-dom/client";
import Comp3Sub from './Comp3Sub.js';
import Comp4Sub from './Comp4Sub.js';
import Comp7Sub from './Comp7Sub.js';
import Comp8Sub from './Comp8Sub.js';
import Comp9Sub from './Comp9Sub.js';
import Comp10Sub from './Comp10Sub.js';
import Comp10_2Sub from './Comp10_2Sub.js';
import Comp11Sub from './Comp11Sub.js';
import Comp12Sub from './Comp12Sub.js';
import Comp13Sub from './Comp13Sub.js';
import FormElectricity from './FormElectricity.js';
import FormRequire from './FormRequire.js';
import Comp3PDF from "./Comp3PDF.js";
import Comp4PDF from "./Comp4PDF.js";
import Comp7PDF from "./Comp7PDF.js";
import Comp8PDF from "./Comp8PDF.js";
import Comp9PDF from "./Comp9PDF.js";
import Comp10PDF from "./Comp10PDF.js";
import Comp10_2PDF from './Comp10_2PDF.js';
import Comp11_2PDF from './Comp11_2PDF.js';
import { validateSelectedFiles } from "./common/fileUploadValidation.js";
import Comp11PDF from "./Comp11PDF.js";
import Comp12PDF from "./Comp12PDF.js";
import Comp13PDF from "./Comp13PDF.js";
import FormRequirePDF from "./FormRequirePDF";
import FormElectricityPDF from "./FormElectricityPDF.js";
import JSZip from "jszip";
import Header from './components/Header.jsx';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Comp6Sub from './Comp6Sub.js';
import Comp5Sub from './Comp5Sub.js';
import Comp11_2Sub from './Comp11_2Sub.js';

const HostMypage = ({ isCarpetSelectedViaPackage, setIsCarpetSelectedViaLease, isCarpetSelectedViaLease, setIsCarpetSelectedViaPackage }) => {
  const FIELD_CONFIGS = [
    {
      key: 'r1',
      label: '必須書類',
      category: 1,
    },
    {
      key: 'o3',
      label: '運送・会場内荷役',
      category: 3,
    },
    {
      key: 'o4',
      label: '床面工事',
      category: 4,
    },
    {
      key: 'o5',
      label: '電気使用',
      category: 5,
    },
    {
      key: 'o6',
      label: '電気備品',
      category: 6,
    },
    {
      key: 'o7',
      label: '給排水・エア・ガス',
      category: 7,
    },
    {
      key: 'o8',
      label: 'パッケージ装飾等',
      category: 8,
    },
    {
      key: 'o9',
      label: '装飾備品レンタル',
      category: 9,
    },
    {
      key: 'o10',
      label: 'PC・ソフトレンタル',
      category: 10,
    },
    {
      key: 'o10_2',
      label: 'インターネット接続',
      category: 14,
    },
    {
      key: 'o11',
      label: '危険物品',
      category: 11,
    },
    {
      key: 'o11_2',
      label: '防炎対象物',
      category: 15,
    },
    {
      key: 'o12',
      label: 'ゴミ・廃材・廃油処理',
      category: 12,
    },
    {
      key: 'o13',
      label: 'ブース平面図',
      category: 13,
    },
  ];

  // 状態管理: 初期値はすべて true（すべて表示）
  const [visibleFields, setVisibleFields] = useState(
    FIELD_CONFIGS.reduce((acc, field) => {
      acc[field.key] = true;
      return acc;
    }, {})
  );

  // チェックボックス変更時
  const handleFieldCheckboxChange = (key) => (e) => {
    setVisibleFields(prev => ({
      ...prev,
      [key]: e.target.checked,
    }));
  };

  const [checked, setChecked] = useState({
    pack: false,
    storage: false,
    iphone: false,
    add: false,
  });
  const [gasChecked, setGasChecked] = useState({
    water: false,
    air: false,
    gas: false,
  });
  const [cleanChecked, setCleanChecked] = useState({
    garbage: false,
    oil: false,
    clean: false,
  });
  const [elecChecked, setElecChecked] = useState({
      v100: false,
      v200: false,
  });
  const [flameChecked, setFlameChecked] = useState({
      flame: false,
      danger: false,
  });
  const [checkedPC, setCheckedPC] = useState({
    pc: false
  });
  const [selectedPlans, setSelectedPlans] = useState([]);

  const [rentalItems, setRentalItems] = useState([]);

  useEffect(() => {
      const fetchItems = async () => {
          try {
              const res = await api.get("/api/master/items-o9");
              setRentalItems(res.data || []);
          } catch (err) {
              console.error("アイテム取得エラー:", err);
          }
      };
      fetchItems();
  }, []);

  const [pcItems, setPcItems] = useState([]);

  useEffect(() => {
      const fetchItems = async () => {
          try {
              const res = await api.get("/api/master/items-o10");
              setPcItems(res.data || []);
          } catch (err) {
              console.error("アイテム取得エラー:", err);
          }
      };
      fetchItems();
  }, []);

  const [elecItems, setElecItems] = useState([]);
  useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items");
                setElecItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

  const [mypageModalOpen, setMypageModalOpen] = useState(false);
  const [mypageExhibitorId, setMypageExhibitorId] = useState(null);
  const [mypageData, setMypageData] = useState(null);

  const [changeModalOpen,setChangeModalOpen] = useState(true);

  const [exhibitors, setExhibitors] = useState([]);
  const [filteredExhibitors, setFilteredExhibitors] = useState([]);
  const [searchName, setSearchName] = useState('');
  const [searchBoothNumber, setSearchBoothNumber] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [statusSummary, setStatusSummary] = useState({
    total_exhibitors: 0,

    required_submission: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    // electricity_submission: {
    //   count: 0,
    //   company_names: [],
    //   complete_count: 0,
    //   complete_company_names: [],
    //   no_count: 0,
    //   no_company_names: [],
    //   not_apply_count: 0,
    //   not_apply_company_names: [],
    // },

    o3_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o4_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o5_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o6_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o7_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o8_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o9_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o10_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o10_2_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o11_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o11_2_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o12_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },

    o13_status: {
      count: 0,
      company_names: [],
      complete_count: 0,
      complete_company_names: [],
      no_count: 0,
      no_company_names: [],
      not_apply_count: 0,
      not_apply_company_names: [],
    },
  });


  const [filterRequired, setFilterRequired] = useState(true);
  const [filterOptional, setFilterOptional] = useState(true);
  const [filterContractor, setFilterContractor] = useState(true);

  const [pendingSearchName, setPendingSearchName] = useState('');
  const [pendingSearchBoothNumber, setPendingSearchBoothNumber] = useState('');
  const [pendingSearchStatus, setPendingSearchStatus] = useState('');
  const [pendingFilterRequired, setPendingFilterRequired] = useState(true);
  const [pendingFilterOptional, setPendingFilterOptional] = useState(true);
  const [pendingFilterContractor, setPendingFilterContractor] = useState(true);
  
  const [selectedFormKey, setSelectedFormKey] = useState(null);
  const [selectedExhibitorId, setSelectedExhibitorId] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyLogs, setHistoryLogs] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [latestHistoryMap, setLatestHistoryMap] = useState({});

  const itemsPerPage = 5;
  const [exhibitorPage, setExhibitorPage] = useState(1);

  const paginatedExhibitors = filteredExhibitors.slice(
    (exhibitorPage - 1) * itemsPerPage,
    exhibitorPage * itemsPerPage
  );

  const [pageInput, setPageInput] = useState(exhibitorPage);

  const handlePageChange = () => {
    let page = Number(pageInput);

    if (isNaN(page)) return;

    if (page < 1) page = 1;
    if (page > exhibitorTotalPages) page = exhibitorTotalPages;

    setExhibitorPage(page);
  };

  const fetchLatestHistory = async (exhibitorId) => {
    const res = await api.get(`/api/latest-history/${exhibitorId}`);

    const map = {};
    res.data.forEach((item) => {
      map[item.submission_number] = item.changed_at;
    });

    setLatestHistoryMap((prev) => ({
      ...prev,
      [exhibitorId]: map,
    }));
  };
 
  useEffect(() => {
    if (!paginatedExhibitors?.length) return;

    const ids = paginatedExhibitors.map((e) => e.exhibitor_id);

    const fetchAll = async () => {
      await Promise.all(
        ids.map((id) => fetchLatestHistory(id))
      );
    };

    fetchAll();
  }, [paginatedExhibitors.map(e => e.exhibitor_id).join(",")]);

  const exhibitorTotalPages = Math.ceil(filteredExhibitors.length / itemsPerPage);

  const [showFormMenu, setShowFormMenu] = useState(false); 
  const [pdfExistsMap, setPdfExistsMap] = useState({});
  const [checkedPdfIds, setCheckedPdfIds] = useState([]);

  // ポップアップ制御用State
  const [openPopup, setOpenPopup] = useState(false);
  const [popupTitle, setPopupTitle] = useState('');
  const [popupCompanyNames, setPopupCompanyNames] = useState([]);

  const handleShowCompanyNames = (title, names) => {
    setPopupTitle(title);
    setPopupCompanyNames(names);
    setOpenPopup(true);
  };

  useEffect(() => {
    api.get('/api/co-dashboard', {
      params: {
        status: searchStatus,
      }
    })
    .then(async res => {
      const rawExhibitors = res.data;
      // console.log(res.data)

      // ✅ 小間番号ソート処理
      const parseBooth = (boothNumber) => {
        if (!boothNumber) return ['ZZZ', 9999];

        // 全角→半角変換＆トリム
        const normalized = boothNumber
          .replace(/[Ａ-Ｚａ-ｚ０-９－ー−]/g, s => {
            if (s === '－' || s === 'ー' || s === '−') return '-';
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
          })
          .trim()
          .toUpperCase();

        // A-1 や A1 形式をキャッチ
        const match = normalized.match(/^([A-Z]+)-?(\d{1,4})$/);
        if (match) {
          return [match[1], parseInt(match[2], 10)]; // 通常番号
        } else {
          // 数字のないものは後ろに並べるため「ZZZ」として扱う
          return ['ZZZ', 9999];
        }
      };

      const sortedExhibitors = [...rawExhibitors].sort((a, b) => {
        const [aLetter, aNum] = parseBooth(a.booth_number);
        const [bLetter, bNum] = parseBooth(b.booth_number);

        if (aLetter < bLetter) return -1;
        if (aLetter > bLetter) return 1;
        return aNum - bNum;
      });

      // ✅ ソート済みで保存
      setExhibitors(sortedExhibitors);

      const ids = sortedExhibitors.map(ex => ex.exhibitor_id);
      const pdfRes = await api.post('/api/pdf-exists-bulk', ids);
      setPdfExistsMap(pdfRes.data);
      // console.log(pdfRes.data);
    })
    .catch(err => console.error('取得失敗:', err));
  }, []);

  useEffect(() => {
    if (mypageModalOpen && mypageExhibitorId != null && exhibitors.length > 0) {
      const target = exhibitors.find((ex) => ex.exhibitor_id === mypageExhibitorId);
      const repId = target?.representative_id;
      if (repId) {
        api.get(`/api/mypage/${repId}`)
          .then(res => setMypageData(res.data))
          .catch(err => console.error("マイページ取得失敗:", err));
      }
    }
  }, [mypageModalOpen, mypageExhibitorId, exhibitors]);

  const isConfirmed = (exhibitor) =>{
   return exhibitor.r1_exhibitor_status === "提出済み";
  };

  const isConfirmedOp = (exhibitor) => {
    const validStatuses = ["提出済み", "申請しない"];
    return (
      validStatuses.includes(exhibitor.o4_exhibitor_status) &&
      validStatuses.includes(exhibitor.o8_exhibitor_status)
    );
  };

  const canDownload = (exhibitor) => {
    return pdfExistsMap[exhibitor.exhibitor_id];
  };

  const getVisibleFields = () => {
    return FIELD_CONFIGS.filter(field => visibleFields[field.key]);
  };

  const userChangeCategories = [1, 2, 4, 11, 13, 15];

  const handleStatusClick = (formKey, exhibitorId, currentStatus, category) => {
    if (currentStatus === '申請しない') return;

    // change_category 判定
    if (userChangeCategories.includes(category)) {
      setChangeModalOpen(true);
    } else {
      setChangeModalOpen(false);
    }

    // 状態更新: 「確認済」以外ならクリックした時点で「確認中」にする
    if (currentStatus !== '確認済') {
      setExhibitors((prev) =>
        prev.map((item) =>
          item.exhibitor_id === exhibitorId
            ? { ...item, [`${formKey}_host_status`]: '確認中' }
            : item
        )
      );
    }

    setSelectedFormKey(formKey);
    setSelectedExhibitorId(exhibitorId);
    setFormModalOpen(true);
  };

  const renderForm = (formKey, exhibitorId) => {
    const key = `${formKey}-${exhibitorId}`;
    switch (formKey) {
      case 'r1':
        return (
          <FormRequire
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            changeModalOpen={changeModalOpen}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      case 'o3':
        return (
          <Comp3Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      case 'o4':
        return (
          <Comp4Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            changeModalOpen={changeModalOpen}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o5':
        return (
          <Comp5Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o6':
        return (
          <Comp6Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o7':
        return (
          <Comp7Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o8':
        return (
          <Comp8Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o9':
        return (
          <Comp9Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o10':
        return (
          <Comp10Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o10_2':
        return (
          <Comp10_2Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o11':
        return (
          <Comp11Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            changeModalOpen={changeModalOpen}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o11_2':
        return (
          <Comp11_2Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            changeModalOpen={changeModalOpen}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o12':
        return (
          <Comp12Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
        case 'o13':
        return (
          <Comp13Sub
            key={key}
            exhibitorId={exhibitorId}
            isCorpModal={true}
            changeModalOpen={changeModalOpen}
            selectedFormKey={formKey}
            selectedExhibitorId={exhibitorId}
            setFormModalOpen={setFormModalOpen}
            setExhibitors={setExhibitors}
            exhibitors={exhibitors}
          />
        );
      default:
        return <p>フォームが見つかりませんでした</p>;
    }
  };


  useEffect(() => {
    api.get('/api/submission-status-summary')
      .then(res => {
        // console.log("/api/submission-status-summary returned!!!!");
        // console.log(res.data);
        setStatusSummary(res.data);
      })
      .catch(err => {
        console.error("提出状況集計の取得に失敗:", err);
      });
  }, []);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('user');
    sessionStorage.clear(); // ← これ追加！
    navigate('/login/host');
  };

  const getStatusImage = (status) => {
    switch (status) {
        case '確認済':
            return '/status_確認済み.png';
        case '確認中':
            return '/status_確認中.png';
        case '未確認':
            return '/status_未確認.png';
        case '1のみ確認済':
            return '/status_1のみ確認済.png';
        case '2のみ確認済':
            return '/status_2のみ確認済.png';
        
        // 👇 提出ステータス追加（例）
        case '提出済み':
            return '/status_提出済み.png';
        case '未提出':
            return '/status_未提出a.png';
        case '再提出':
            return '/status_再提出.png';
        case '申請しない':
            return '/status_申請しない.png';


        default:
            return '/status_未提出a.png';
    }
};

  useEffect(() => {
    const visibleFields = getVisibleFields();

    const filtered = exhibitors.filter((exhibitor) => {
      const nameMatch = String(exhibitor.company_name ?? '').includes(searchName);
      const boothNumberMatch = String(exhibitor.booth_number ?? '').includes(searchBoothNumber);

      // ---- ここがポイント ----
      const change_category = [1, 2, 4, 11, 13];

      // change_category の field の中で検索条件に合致するものが1つでもあるか
      const hasMatchingStatus = visibleFields
        .filter((field) => change_category.includes(field.category))
        .some((field) => {
          const exhibitorStatus = exhibitor[`${field.key}_exhibitor_status`];
          const hostStatus = exhibitor[`${field.key}_host_status`];
          const corporateStatus = exhibitor[`${field.key}_corporate_status`];
          const candidates = [
            exhibitorStatus,
            hostStatus,
            corporateStatus,
          ].filter(Boolean);

          const STATUS_PRIORITY = [
            '未提出','未確認','再提出','1のみ確認済','2のみ確認済','確認済','申請しない'
          ];

          let currentStatus = '未提出';

          if (
            exhibitorStatus === '再提出' &&
            hostStatus === '未確認' &&
            corporateStatus === '未確認'
          ) {
            currentStatus = '再提出';
          } else if (
            hostStatus === '未確認' &&
            corporateStatus === '未確認' &&
            exhibitorStatus !== '再提出'
          ) {
            currentStatus = '未確認';
          } else {
            for (const status of STATUS_PRIORITY) {
              if (candidates.includes(status)) {
                currentStatus = status;
                break;
              }
            }
          }

          // 🔹 searchStatus が空なら全部 OK
          if (searchStatus.length === 0) return true;

          return searchStatus.includes(currentStatus);
        });

      // ---- 行表示判定 ----
      const shouldShowRow = nameMatch && boothNumberMatch && (searchStatus.length === 0 || hasMatchingStatus);

      return shouldShowRow;
    });

    setFilteredExhibitors(filtered);
  }, [
    searchName,
    searchBoothNumber,
    searchStatus,
    filterRequired,
    filterOptional,
    filterContractor,
    exhibitors
  ]);

  const applyFilters = () => {
    setSearchName(pendingSearchName);
    setSearchBoothNumber(pendingSearchBoothNumber);
    setSearchStatus(pendingSearchStatus);
    setFilterRequired(pendingFilterRequired);
    setFilterOptional(pendingFilterOptional);
    setFilterContractor(pendingFilterContractor);
  };

  // 絞り込み削除ボタン押下時
  const clearFilters = () => {
    setPendingSearchName('');
    setPendingSearchBoothNumber('');
    setPendingSearchStatus([]);
    setPendingFilterRequired(true);
    setPendingFilterOptional(true);
    setPendingFilterContractor(true);
  };

  const handleExcelDownload = async (exhibitorId, companyName) => {
    try {
      const response = await api.get(
        `/api/excel-download/${exhibitorId}`,
        {
          responseType: 'blob',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          params: {
            companyName,
            t: new Date().getTime() // キャッシュバスター
          }
        }
      );

      const blob = new Blob([response.data], { type: 'application/zip' });

      const safeFileName = `${companyName.replace(/[\\/:*?"<>|]/g, '_')}_excels.zip`;

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', safeFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text();   // Blob → string
          const json = JSON.parse(text);                   // string → JSON
          if (json.detail) {
            alert(json.detail);
            return;
          }
        } catch (e) {
          console.error("エラーメッセージのパースに失敗:", e);
        }
      }

      console.error("Excelダウンロードに失敗:", error);
      alert("ダウンロードに失敗しました。");
    }
  };

  // 見積書用
  const handlePdfDownload = async (exhibitorId, companyName) => {
    try {
      const response = await api.get(
        `/api/pdf-download/${exhibitorId}`,
        {
          responseType: 'blob',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'
          },
          params: {
            t: new Date().getTime()
          }
        }
      );

      const blob = new Blob([response.data], { type: 'application/zip' });
      const safeFileName = `${companyName.replace(/[\\/:*?"<>|]/g, '_')}_pdfs.zip`;

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', safeFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      alert("PDFのZIPダウンロードが完了しました。");
    } catch (error) {
      console.error("PDFダウンロードに失敗:", error);
      alert("PDFのダウンロードに失敗しました。");
    }
  };

  const fileInputsRef = useRef({}); // 複数出展者に対応した動的 ref 管理

  const triggerFileInput = (exhibitorId) => {
    if (fileInputsRef.current[exhibitorId]) {
      fileInputsRef.current[exhibitorId].click();
    }
  };

  const handleExcelUpload = async (exhibitorId, event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validation = validateSelectedFiles([file]);
    if (!validation.valid) {
      alert(validation.message);
      event.target.value = null;
      return;
    }

    // サーバー側で既に生成されたファイル一覧（想定されるファイル名群）を先に取得
    try {
      const res = await api.get(`/api/excel-upload-allowed-files/${exhibitorId}`);
      const allowedFileNames = res.data.allowed_file_names; // ["4.xlsx", "4_請求先名A.xlsx", ...]

      if (!allowedFileNames.includes(file.name)) {
        alert(`${allowedFileNames.join(" / ")} のいずれかをアップロードしてください。`);
        return;
      }

      const formData = new FormData();
      formData.append('company_id', exhibitorId);
      formData.append('file', file);

      await api.post('/api/excel-upload/', formData);
      // PDF存在状態を即更新
      setPdfExistsMap(prev => ({
        ...prev,
        [exhibitorId]: true
      }));
      alert("アップロードが完了しました");
    } catch (error) {
      console.error("アップロードエラー:", error);
      alert(error.response?.data?.detail || "アップロードに失敗しました。");
    }
  };

  const waitForIdleAndStableDOM = (targetElement, timeout = 3000) =>
    new Promise((resolve) => {
      let stableCount = 0;
      let lastHeight = targetElement.offsetHeight;

      const checkStable = () => {
        const nowHeight = targetElement.offsetHeight;
        if (nowHeight === lastHeight) {
          stableCount++;
          if (stableCount >= 3) {
            return resolve();
          }
        } else {
          stableCount = 0;
          lastHeight = nowHeight;
        }
        setTimeout(checkStable, 150);
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => {
          setTimeout(checkStable, 150);
        }, { timeout });
      } else {
        setTimeout(checkStable, 150);
      }
  });

  const pdfDownloadInProgressRef = useRef(false);
  const [pdfDownloading, setPdfDownloading] = useState(false);

  // 申請書用
  const handlePDFDownload = async () => {
    if (pdfDownloadInProgressRef.current || checkedPdfIds.length === 0) return;
    pdfDownloadInProgressRef.current = true;
    setPdfDownloading(true);
    try {
    const fieldMap = Object.fromEntries(FIELD_CONFIGS.map(f => [f.key, f]));
    const selectedPairs = checkedPdfIds.map((id) => {
      const [exhibitor_id_raw, ...keyParts] = id.split("_");
      return { exhibitor_id: Number(exhibitor_id_raw), key: keyParts.join("_") };
    });

    // console.log('selectedPairs', selectedPairs);

    const fetchCorporateInfo = async () => {
      try {
        const params = new URLSearchParams();
        const exhibitorIds = new Set(selectedPairs.map(pair => pair.exhibitor_id));
        const categories = new Set(selectedPairs.map(pair => fieldMap[pair.key]?.category).filter(Boolean));
        exhibitorIds.forEach(id => params.append("exhibitor_ids", id));
        categories.forEach(category => params.append("categories", category));
        const res = await api.get(`/api/corporate-all`, { params });

        if (res.status !== 200) {
          throw new Error("データ取得に失敗しました");
        }

        return res.data;
      } catch (err) {
        console.error("API呼び出し失敗:", err);
        throw err;
      }
    };

    const corporateInfo = await fetchCorporateInfo();
    const corporateDataMap = corporateInfo.data;

    // console.log('corporateDataMap', corporateDataMap);

    const targets = selectedPairs.map(({ exhibitor_id, key }) => {
      const fieldConfig = fieldMap[key];
      if (!fieldConfig) return null;

      const category = fieldConfig.category;
      const forms = corporateDataMap[category];
      if (!forms) return null;

      const matchedForm = forms.find(f => f.exhibitor_id === exhibitor_id);
      if (!matchedForm) return null;

      return {
        exhibitor_id,
        company_name: matchedForm.company_name,
        selectedCategories: [key],
        categories: {
          [key]: matchedForm,
        }
      };
    }).filter(Boolean);

    if (!targets.length) return alert("出力対象が選択されていません");
    // console.log(targets);

    // 一覧で取得済みの user_id を使い、書類ごとの追加通信を避ける。
    const exhibitorMap = new Map(exhibitors.map(ex => [ex.exhibitor_id, ex]));
    const targetsWithUser0 = targets.map(row => ({
      ...row,
      User0: exhibitorMap.get(row.exhibitor_id)?.user_id === 0,
    }));

    for (const row of targetsWithUser0) {
      for (const fieldKey of row.selectedCategories) {
        const form = row.categories[fieldKey];
        const fieldConfig = fieldMap[fieldKey];

        // console.log(form);

        const reqData = {
          company_name: form.company_name,
          booth_number: form.booth_number,
          department: form.department,
          address: form.address,
          phone_number: form.phone_number,
          email: form.email,
          user_name: form.user_name,
          r1: form.r1?.[0] || {},
          r2: form.r2?.[0] || {},
        };

        const elecData = {
          company_name: form.company_name,
          booth_number: form.booth_number,
          department: form.department,
          address: form.address,
          phone_number: form.phone_number,
          email: form.email,
          user_name: form.user_name,
          o5: form.o5?.[0] || {},
          o6: form.o6?.[0] || {},
        };

        if (!fieldConfig) continue;

        const container = document.createElement("div");
        container.style.width = "210mm";
        document.body.appendChild(container);
        const root = createRoot(container);

        try {
        const renderComponent = (formKey) => {
          switch (formKey) {
            case 'r1':
              const hasPackage = !!(
                reqData?.r1?.package_company_name ||
                reqData?.r1?.package_company_tel ||
                reqData?.r1?.package_phone_number ||
                reqData?.r1?.package_company_zip ||
                reqData?.r1?.package_company_address ||
                reqData?.r1?.package_company_fax ||
                reqData?.r1?.package_name
              );

              const hasElec = !!(
                reqData?.r1?.elec_company_name ||
                reqData?.r1?.elec_company_tel ||
                reqData?.r1?.elec_phone_number ||
                reqData?.r1?.elec_company_zip ||
                reqData?.r1?.elec_company_address ||
                reqData?.r1?.elec_company_fax ||
                reqData?.r1?.elec_name
              );

              const hasInfla = !!(
                reqData?.r1?.infla_company_name ||
                reqData?.r1?.infla_company_tel ||
                reqData?.r1?.infla_phone_number ||
                reqData?.r1?.infla_company_zip ||
                reqData?.r1?.infla_company_address ||
                reqData?.r1?.infla_company_fax ||
                reqData?.r1?.infla_name
              );

              const hasCargo = !!(
                reqData?.r1?.cargo_company_name ||
                reqData?.r1?.cargo_company_tel ||
                reqData?.r1?.cargo_phone_number ||
                reqData?.r1?.cargo_company_zip ||
                reqData?.r1?.cargo_company_address ||
                reqData?.r1?.cargo_company_fax ||
                reqData?.r1?.cargo_name
              );

              // まとめる
              const checkedR1 = {
                has_package_company: hasPackage,
                has_elec_company: hasElec,
                has_infla_company: hasInfla,
                has_cargo_company: hasCargo,
              };
              return <FormRequirePDF reqData={{ 
                ...reqData, 
                r1: { ...reqData.r1, ...checkedR1 } 
              }} User0={row.User0} />;
            case 'o3':
              return <Comp3PDF formData={form} />;
            case 'o4':
              return <Comp4PDF formData={form} />;
            case 'o5':
              const hasV100 =
                form?.o5?.[0]?.details_100?.some(d =>
                  d.device_100_name || d.quantity_100 || d.number_100 || d.total_100 || d.ex_100
                ) ||
                (form?.o5?.[0]?.quantity_100v !== null &&
                form?.o5?.[0]?.quantity_100v !== undefined &&
                Number(form?.o5?.[0]?.quantity_100v) > 0);

              const hasV200 =
                form?.o5?.[0]?.details_200?.some(d =>
                  d.device_200_name || d.quantity_200 || d.number_200 || d.total_200 || d.ex_200
                ) ||
                (form?.o5?.[0]?.quantity_200v !== null &&
                form?.o5?.[0]?.quantity_200v !== undefined &&
                Number(form?.o5?.[0]?.quantity_200v) > 0);

              const localChecked = {
                v100: !!hasV100,
                v200: !!hasV200
              };

              return <FormElectricityPDF elecData={form} checked={localChecked} elecItems={elecItems} />;
            case 'o7':
              const hasWater = form.water;
              const hasAir = form.air;
              const hasGas = form.gas;

              const gasObj = {
                water: !!hasWater,
                air: !!hasAir,
                gas: !!hasGas,
              };

              setGasChecked(gasObj);
              return <Comp7PDF formData={form} checked={gasObj} />;
           case 'o8':
            let plans = [];
            if (form.plan && Array.isArray(form.plan)) {
              plans = form.plan.map(p => ({
                value: p.value,
                label: p.label,
                quantity: p.quantity || 1,
              }));
              setSelectedPlans(plans); // ← stateに残したいならここはそのまま
            }

            const hasPack = plans.length > 0 ||
              form.plate_select ||
              form.plate_info ||
              form.carpet_color ||
              form.outlet ||
              form.add_select ||
              (form.add_detail && form.add_detail !== "A:0,B:0,C:0,D:0");

            const hasStorage = (form.normal_box && form.normal_box !== 0) ||
              (form.other_box && form.other_box !== 0);

            const hasIphone = form.smartphone !== null || (form.add_smartphone && form.add_smartphone > 0);

            const hasAdd = (form.add_smartphone && form.add_smartphone > 0);

            const checkedObj = {
              pack: !!hasPack,
              storage: !!hasStorage,
              iphone: !!hasIphone,
              add: !!hasAdd,
            };

            setChecked(checkedObj);

            return <Comp8PDF formData={form} checked={checkedObj} selectedPlans={plans} />;
            case 'o9':
              return <Comp9PDF formData={form} rentalItems={rentalItems} />;
            case 'o10':
              const hasPC =
              !!(form.move_in ||
              form.move_in_detail ||
              form.move_out ||
              form.move_out_detail ||
              (Array.isArray(form.details) && form.details.length > 0));
              const checkedPCObj ={
                pc: !!hasPC
              }
              setCheckedPC(checkedPCObj);
              return <Comp10PDF formData={form} items={pcItems} checked={checkedPCObj} />;
            case 'o10_2':
              return <Comp10_2PDF formData={form} />;
            case "o11": {
              return (
                <Comp11PDF
                  formData={form}
                />
              );
            }
            case 'o11_2':
              return <Comp11_2PDF formData={form} />;
            case 'o12':
              const hasGarbage = form.garbage_plan?.length > 0;
              const hasOil = form.lubricating_oil || form.waste_oil;
              const hasClean = form.cleanup;

              const cleanObj = {
                garbage: !!hasGarbage,
                oil: !!hasOil,
                clean: !!hasClean,
              };

              setCleanChecked(cleanObj);
              return <Comp12PDF formData={form} checked={cleanObj} />;
            case 'o13':
              return <Comp13PDF formData={form} />;
            default:
              return <p>フォームが見つかりませんでした</p>;
          }
        };

        root.render(
          <div
            style={{
              width: "210mm",
              minHeight: "297mm",
              padding: "10mm",
              background: "#fff",
              overflow: "visible",
            }}
          >
            {renderComponent(fieldKey)}
          </div>
        );

        const baseUrl =
        window.location.hostname === 'localhost'
          ? 'http://127.0.0.1:8000'          // ローカル開発用
          : 'https://messenagoya.ex-link.net'; // 本番 HTTPS

        await waitForIdleAndStableDOM(container);
        container.style.height = `${container.scrollHeight}px`;

        // ---- ここを差し替え ----
        if (fieldKey === "o13") {
          // ZIP先にダウンロード
          const res = await fetch(`${baseUrl}/api/o13/download/${row.exhibitor_id}`, { cache: "no-store" });
          if (!res.ok) throw new Error("zip ダウンロード失敗");
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${row.company_name}_ブース平面図.zip`;
          a.click();
          window.URL.revokeObjectURL(url);

          await waitForIdleAndStableDOM(container);

          await saveElementPdf(container, `${row.company_name}_o13.pdf`, { scale: 2, paginate: false });

        } else {
          // o13以外はPDF生成 → その場でダウンロード
          const company = row.company_name || "output";
          const safeCompany = company.replace(/[\\/:*?"<>|]/g, '_');
          const label = fieldConfig.label || fieldKey;

          // ✅ここで即ダウンロード
          await saveElementPdf(container, `${safeCompany}_${label}.pdf`);
        }
        // ---- 差し替えここまで ----

        } finally {
          root.unmount();
          document.body.removeChild(container);
        }

        // 次に行く前にちょっと待機（ブラウザ負荷対策）
        await new Promise(res => setTimeout(res, 800));
      }
    }
    } catch (error) {
      console.error("申請書PDFダウンロードに失敗:", error);
      alert("申請書PDFのダウンロードに失敗しました。");
    } finally {
      pdfDownloadInProgressRef.current = false;
      setPdfDownloading(false);
    }
  };

  const handleEXCELDownload = async () => {
    try {
      const res = await api.post(
        "/api/export-excel",
        { view_category: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15] },
        { responseType: "blob" } // Excelはバイナリ
      );

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "申請書一覧.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Excelダウンロード失敗:", err);
    }
  };

  // 履歴確認
  const handleHistoryCheck = async (exhibitorId) => {
    try {
      setLoadingHistory(true);

      const response = await api.get(`/api/all-sub-logs/${exhibitorId}`);
      setHistoryLogs(response.data);
      setHistoryModalOpen(true);
    } catch (error) {
      console.error(error);
      alert("履歴の取得に失敗しました");
    } finally {
      setLoadingHistory(false);
    }
  };

  const formatDateTime = (value) => {
  if (!value) return "";
  return value.replace("T", "-");
  };

  const CATEGORY_MAP = {
    1: "必須書類",
    3: "運送・会場内荷役",
    4: "床面工事",
    5: "電気使用",
    6: "電気備品",
    7: "給排水・エア・ガス",
    8: "パッケージ装飾",
    9: "装飾備品レンタル",
    10: "PC・ソフトレンタル",
    11: "危険物品",
    12: "ゴミ・廃材・廃油処理",
    13: "ブース平面図",
    14: "インターネット接続",
    15: "防炎対象物",
  };

  useConfirmBackLogout(navigate);

  return (
    <div>
        <Header
          title="メッセナゴヤ 主催者ダッシュボード"
        />
        <Container sx={{ mt: 5 }}>
          <Box sx={{ display: 'flex' }}>
            {/* 左メニュー */}
            <Box sx={{ width: '15%', pr: 2, borderRight: '1px solid #ccc' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box className="menu-item" onClick={() => navigate('/host-dashboard')}>
                  申請状況
                </Box>
                <Box
                  className="menu-group"
                  id="hover-block"
                  onMouseEnter={() => {}}
                  onMouseLeave={() => {}}
                >
                  <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                    会社情報
                  </Box>
                    {showFormMenu && (
                      <Box className="hover-menu">
                        <Typography
                          sx={{ color: '#0071bc', textAlign: 'center' }}
                          className='form-button'
                          onClick={() => navigate('/exhibitor-info')}
                        >
                          出展者
                        </Typography>
                        <Typography
                          sx={{ color: '#0071bc', textAlign: 'center' }}
                          className='form-button'
                          onClick={() => navigate('/corporate-info')}
                        >
                          協力会社
                        </Typography>
                      </Box>
                    )}
                </Box>
                <Box className="menu-item" onClick={() => navigate('/create-mail')}>
                  メール作成
                </Box>
                <Box className="menu-item" onClick={() => navigate('/create-notice')}>
                  お知らせ作成
                </Box>
                <Box className="menu-item" onClick={() => navigate('/form-history')}>
                  再提出ログ確認
                </Box>
              </Box>
            </Box>

            {/* メインコンテンツ（右） */}
            <Box sx={{ width: '85%', pl: 2 }}>
              <Box>
                <Box sx={{ mt: 0 }} className="form-status-box">
                  <Box className='form-status-title' sx={{ display: 'flex' , alignItems: 'center' , justifyContent: 'space-between' }}>
                    <Typography variant="h6" sx={{ mb: 0 }}>　申請書提出状況</Typography>
                    <Typography variant="h6">申込件数:{statusSummary.total_exhibitors ?? '-'} 社</Typography>
                  </Box>
                  <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)', // 1行4個ずつ
                    gap: 2 // spacing（マージン相当）
                  }}>
                    <Box sx={{ textAlign: 'center', m: 2}}>
                      <Typography variant="subtitle2">必須書類</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '必須書類確認済',
                              statusSummary.required_submission.complete_company_names
                            )}
                          >
                            {statusSummary.required_submission.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '必須書類未確認',
                              statusSummary.required_submission.no_company_names
                            )}
                          >
                            {statusSummary.required_submission.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">運送・会場内荷役作業申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '運送関連確認済',
                              statusSummary.o3_status.complete_company_names
                            )}
                          >
                            {statusSummary.o3_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '運送関連申請しない',
                              statusSummary.o3_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o3_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '運送関連未確認',
                              statusSummary.o3_status.no_company_names
                            )}
                          >
                            {statusSummary.o3_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">床面工事施工申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '床面工事確認済',
                              statusSummary.o4_status.complete_company_names
                            )}
                          >
                            {statusSummary.o4_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '床面工事申請しない',
                              statusSummary.o4_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o4_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '床面工事未確認',
                              statusSummary.o4_status.no_company_names
                            )}
                          >
                            {statusSummary.o4_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">電気（電力）使用申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '電気関連確認済',
                              statusSummary.o5_status.complete_company_names
                            )}
                          >
                            {statusSummary.o5_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '電気関連申請しない',
                              statusSummary.o5_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o5_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '電気関連未確認',
                              statusSummary.o5_status.no_company_names
                            )}
                          >
                            {statusSummary.o5_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">電気備品レンタル申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '電気関連確認済',
                              statusSummary.o6_status.complete_company_names
                            )}
                          >
                            {statusSummary.o6_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '電気関連申請しない',
                              statusSummary.o6_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o6_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '電気関連未確認',
                              statusSummary.o6_status.no_company_names
                            )}
                          >
                            {statusSummary.o6_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">給排水・エア・ガス工事申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '給排水・エア・ガス確認済',
                              statusSummary.o7_status.complete_company_names
                            )}
                          >
                            {statusSummary.o7_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '給排水・エア・ガス申請しない',
                              statusSummary.o7_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o7_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '給排水・エア・ガス未確認',
                              statusSummary.o7_status.no_company_names
                            )}
                          >
                            {statusSummary.o7_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">パッケージ装飾・出展者専用倉庫・名刺交換用iPhoneパッケージ申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'パッケージ確認済',
                              statusSummary.o8_status.complete_company_names
                            )}
                          >
                            {statusSummary.o8_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'パッケージ申請しない',
                              statusSummary.o8_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o8_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'パッケージ未確認',
                              statusSummary.o8_status.no_company_names
                            )}
                          >
                            {statusSummary.o8_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">装飾備品レンタル申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '装飾備品確認済',
                              statusSummary.o9_status.complete_company_names
                            )}
                          >
                            {statusSummary.o9_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '装飾備品申請しない',
                              statusSummary.o9_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o9_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '装飾備品未確認',
                              statusSummary.o9_status.no_company_names
                            )}
                          >
                            {statusSummary.o9_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">PC・ソフトレンタル申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'PC・ソフト確認済',
                              statusSummary.o10_status.complete_company_names
                            )}
                          >
                            {statusSummary.o10_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'PC・ソフト申請しない',
                              statusSummary.o10_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o10_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'PC・ソフト未確認',
                              statusSummary.o10_status.no_company_names
                            )}
                          >
                            {statusSummary.o10_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">インターネット接続申請</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'インターネット接続確認済',
                              statusSummary?.o10_2_status.complete_company_names
                            )}
                          >
                            {statusSummary?.o10_2_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'インターネット接続申請しない',
                              statusSummary?.o10_2_status.not_apply_company_names
                            )}
                          >
                            {statusSummary?.o10_2_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'インターネット接続未確認',
                              statusSummary?.o10_2_status.no_company_names
                            )}
                          >
                            {statusSummary?.o10_2_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">防炎対象物品申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '防炎確認済',
                              statusSummary.o11_2_status.complete_company_names
                            )}
                          >
                            {statusSummary.o11_2_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '防炎申請しない',
                              statusSummary.o11_2_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o11_2_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '防炎未確認',
                              statusSummary.o11_2_status.no_company_names
                            )}
                          >
                            {statusSummary.o11_2_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">危険物品申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '危険物品確認済',
                              statusSummary.o11_status.complete_company_names
                            )}
                          >
                            {statusSummary.o11_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '危険物品申請しない',
                              statusSummary.o11_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o11_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '危険物品未確認',
                              statusSummary.o11_status.no_company_names
                            )}
                          >
                            {statusSummary.o11_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">廃材・廃油処理・小間内清掃申込</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '廃材・廃油・清掃確認済',
                              statusSummary.o12_status.complete_company_names
                            )}
                          >
                            {statusSummary.o12_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '廃材・廃油・清掃申請しない',
                              statusSummary.o12_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o12_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              '廃材・廃油・清掃未確認',
                              statusSummary.o12_status.no_company_names
                            )}
                          >
                            {statusSummary.o12_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'center', m: 2 }}>
                      <Typography variant="subtitle2">ブース平面図</Typography>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography className='font18'>
                          確認済<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'ブース平面図確認済',
                              statusSummary.o13_status.complete_company_names
                            )}
                          >
                            {statusSummary.o13_status.complete_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          申請しない<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'ブース平面図申請しない',
                              statusSummary.o13_status.not_apply_company_names
                            )}
                          >
                            {statusSummary.o13_status.not_apply_count}
                          </span>社
                        </Typography>
                        <Typography className='font18'>
                          未確認<br/ >
                          <span
                            className="big-number"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleShowCompanyNames(
                              'ブース平面図未確認',
                              statusSummary.o13_status.no_company_names
                            )}
                          >
                            {statusSummary.o13_status.no_count}
                          </span>社
                        </Typography>
                      </Box>
                    </Box>

                    {/* ポップアップ */}
                    <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
                      <DialogTitle>{popupTitle}</DialogTitle>
                      <DialogContent>
                        <List>
                          {popupCompanyNames.length > 0 ? popupCompanyNames.map((name, idx) =>
                            <ListItem key={idx}><ListItemText primary={name} /></ListItem>
                          ) : <ListItem><ListItemText primary="該当なし" /></ListItem>}
                        </List>
                      </DialogContent>
                    </Dialog>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ mt: 6 }} className="notice-box">
                <Box className='notice-title'>
                  <Typography variant="h6" gutterBottom className='title'><i className="bi bi-list"></i>検索条件</Typography>
                </Box>
                <Box>
                  <Box sx={{ display: 'flex' , alignItems: "center", px: 5 , py: 3 }}>
                    <Typography variant="h6" sx={{ mr:3 }}>会社名　　</Typography>
                    <TextField
                      variant="outlined"
                      value={pendingSearchName}
                      onChange={(e) => setPendingSearchName(e.target.value)}
                    />
                  </Box>
                  <Box sx={{ display: 'flex' , alignItems: "center", px: 5 , py: 3 }}>
                    <Typography variant="h6" sx={{ mr:3 }}>小間番号</Typography>
                    <TextField
                      variant="outlined"
                      value={pendingSearchBoothNumber}
                      onChange={(e) => setPendingSearchBoothNumber(e.target.value)}
                    />
                  </Box>
                </Box>
                {/* フィルターUI */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3, mt: 2 }}>
                  
                  <Typography sx={{ mx: 5 }} className='button-poi'>申請書</Typography>

                  <Box sx={{px: 2}}>
                    <FormGroup row>
                      {FIELD_CONFIGS.map((field) => (
                        <FormControlLabel
                          key={field.key}
                          control={
                            <Checkbox
                              checked={visibleFields[field.key]}
                              onChange={handleFieldCheckboxChange(field.key)}
                            />
                          }
                          label={field.label}
                        />
                      ))}
                    </FormGroup>
                  </Box>

                  {/* 提出・確認ステータス絞り込み */}
                  <FormControl component="fieldset" sx={{ display: 'flex', flexDirection: 'column', px: 5 }}>
                    <FormGroup row>
                      {[
                        { value: '未提出', label: '未提出' },
                        { value: '未確認', label: '未確認' },
                        { value: '再提出', label: '再提出' },
                        { value: '申請しない', label: '申請しない' },
                        { value: '確認済', label: '完了' }, // 表示名は「完了」
                      ].map((item) => (
                        <FormControlLabel
                          key={item.value}
                          control={
                            <Checkbox
                              checked={pendingSearchStatus.includes(item.value)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setPendingSearchStatus([...pendingSearchStatus, item.value]);
                                } else {
                                  setPendingSearchStatus(
                                    pendingSearchStatus.filter((status) => status !== item.value)
                                  );
                                }
                              }}
                            />
                          }
                          label={item.label}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>

                  {/* 必須・任意のチェックボックス */}
                  {/* <FormGroup row sx={{ px:5 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={pendingFilterRequired}
                          onChange={(e) => setPendingFilterRequired(e.target.checked)}
                        />
                      }
                      label="必須"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={pendingFilterOptional}
                          onChange={(e) => setPendingFilterOptional(e.target.checked)}
                        />
                      }
                      label="任意"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={pendingFilterContractor}
                          onChange={(e) => setPendingFilterContractor(e.target.checked)}
                        />
                      }
                      label="協力会社"
                    />
                  </FormGroup> */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 5, mt: 2, gap: 2 }}>
                    <Button variant="outlined" color="secondary" onClick={clearFilters}>
                      <i className="bi bi-eraser"></i>絞込削除
                    </Button>
                    <Button variant="contained" color="primary" onClick={applyFilters} sx={{ px:4 }}>
                      <i className="bi bi-search"></i>検索
                    </Button>
                  </Box>
                </Box>
              </Box>

              <Box className="notice-box" sx={{ px:2, py:3,  }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant='h5' className='title' sx={{ mb: 3, px: 4 }}>申請書一覧</Typography>
                  <Box sx={{ display: 'flex' , gap: '10px'}}>
                    <Button onClick={handleEXCELDownload} variant="outlined" color="secondary" sx={{mb: 3}}>Excelダウンロード</Button>
                    <Button variant="outlined" color="secondary" onClick={handlePDFDownload} disabled={pdfDownloading || checkedPdfIds.length === 0} sx={{ mb: 3, px: 2 }}>{pdfDownloading ? "PDF生成中..." : "PDFダウンロード"}</Button>
                  </Box>
                </Box>
                <Box sx={{ overflowX: 'auto' }}>
                  {/* 見出しラベル */}
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 0, backgroundColor: '#0071BC', color: '#FFF', textAlign: 'center' , minWidth: '1820px', overflowX: 'hidden' }}>
                    <Typography sx={{ padding: '10px 0' ,width: 120, fontWeight: 'bold', borderRight: '1px solid #fff' }}>履歴確認</Typography>
                    <Typography sx={{ padding: '10px 0' ,width: 120, fontWeight: 'bold', borderRight: '1px solid #fff' }}>会社名</Typography>
                    <Typography sx={{ padding: '10px 0' ,width: 90, fontWeight: 'bold', borderRight: '1px solid #fff' }}>小間番号</Typography>
                    {getVisibleFields().map((field) => {
                      const { label } = field;
                      
                      const handleColumnSelect = (key) => {
                        // まずは全出展者の対象IDを取得
                        const columnIds = exhibitors
                          .filter((exhibitor) => {
                            // 各出展者の currentStatus を算出して「申請しない」を除外
                            const exhibitorKey = `${key}_exhibitor_status`;
                            const hostKey = `${key}_host_status`;
                            const corporateKey = `${key}_corporate_status`;

                            // --- 特殊処理: o5/o6 のホストステータス比較 ---
                            let displayHostStatus = exhibitor[hostKey];
                            if (key === 'o5') {
                              const o5 = exhibitor.o5_host_status;
                              const o6 = exhibitor.o6_host_status;

                              if (o5 === '申請しない' && (o6 === '未確認' || o6 === '確認済')) {
                                displayHostStatus = o6; // o6優先
                              } else if (o5 === '申請しない' && o6 === '申請しない') {
                                displayHostStatus = '申請しない';
                              } else {
                                displayHostStatus = o5;
                              }
                            }

                            // 候補まとめ
                            const candidates = [
                              exhibitor[exhibitorKey],
                              displayHostStatus,
                              exhibitor[corporateKey],
                            ].filter(Boolean);

                            // 優先度リスト
                            const STATUS_PRIORITY = [
                              '再提出',
                              '未提出',
                              '未確認',
                              '確認中',
                              '1のみ確認済',
                              '2のみ確認済',
                              '確認済',
                              '申請しない',
                            ];

                            let currentStatus = '未提出';
                            for (const status of STATUS_PRIORITY) {
                              if (candidates.includes(status)) {
                                currentStatus = status;
                                break;
                              }
                            }

                            // 申請しないは除外
                            return currentStatus !== '申請しない';
                          })
                          .map((exhibitor) => `${exhibitor.exhibitor_id}_${key}`);

                        // すでに全部チェック済みかどうか
                        const allChecked = columnIds.every((id) => checkedPdfIds.includes(id));

                        setCheckedPdfIds((prev) => {
                          if (allChecked) {
                            // 全解除
                            return prev.filter((id) => !columnIds.includes(id));
                          } else {
                            // 未チェック分だけ追加
                            return [...prev, ...columnIds.filter((id) => !prev.includes(id))];
                          }
                        });
                      };

                      return (
                        <Box
                          key={field.key}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            borderRight: "1px solid #fff",
                            width: 110,
                            padding: "10px 0",
                          }}
                        >
                          {/* ラベル */}
                          <Typography sx={{ fontWeight: "bold", height: 50 }}>
                            {label}
                          </Typography>

                          {/* 一括チェックボタン */}
                          <Button
                            variant="outlined"
                            size="small"
                            color="white"
                            sx={{ mt: 1 }}
                            onClick={() => handleColumnSelect(field.key)}
                          >
                            一括
                          </Button>
                        </Box>
                      );
                    })}
                    <Typography sx={{ width: 180, fontWeight: 'bold' }}>見積書</Typography> {/* 触らへん！ */}
                  </Box>
                  <Box>
                    <>
                      {paginatedExhibitors.map((exhibitor, index) => {
                        const isEven = index % 2 === 0;

                        // console.log('---- exhibitor row ----');
                        // console.log('exhibitor:', exhibitor.company_name, 'booth:', exhibitor.booth_number);

                        return (
                          <>
                          <Box
                            key={exhibitor.exhibitor_id}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              mb: 0,
                              textAlign: 'center',
                              backgroundColor: isEven ? '#f5f5f5' : '#ffffff',
                              border: '1px solid #ccc',
                              minWidth: '1820px',
                              overflowX: 'hidden'
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              color="secondary"
                              sx={{ width: 120, borderRight: '1px solid #ccc', py: 1, px:2 }}
                              onClick={() => handleHistoryCheck(exhibitor.exhibitor_id)}
                            >
                              全履歴確認
                            </Button>
                            {/* 出展者情報 */}
                            <Typography sx={{ width: 120, borderRight: '1px solid #ccc', py: 1 }}
                              onClick={() => { setMypageExhibitorId(exhibitor.exhibitor_id); setMypageModalOpen(true); }}
                            >
                              {exhibitor.company_name}
                            </Typography>
                            <Typography sx={{ width: 90, borderRight: '1px solid #ccc', py: 1 }}>
                              {exhibitor.booth_number}
                            </Typography>

                            {/* 出展者書類ステータス */}
                            {getVisibleFields().map((field) => {
                              const { key, label, statusType, category } = field;
                              const exhibitorKey = `${key}_exhibitor_status`;
                              const hostKey = `${key}_host_status`;
                              const corporateKey = `${key}_corporate_status`;

                              const historyData = latestHistoryMap[exhibitor.exhibitor_id]?.[category];

                              let dateColor = "inherit";
                              let formattedDate = "";

                              if (historyData) {
                                const changedDate = new Date(
                                  new Date(historyData).getTime() + 9 * 60 * 60 * 1000
                                );

                                const now = new Date();
                                const diffDays = (now - changedDate) / (1000 * 60 * 60 * 24);

                                formattedDate = changedDate.toLocaleString("ja-JP", {
                                  month: "2-digit",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: false,
                                });

                                // 提出後3日以内のみ赤色
                                if (diffDays <= 3) {
                                  dateColor = "rgb(255, 0, 0)";
                                }
                              }

                              // === 特殊処理: o5/o6 のホストステータス比較 ===
                              // let displayHostStatus = exhibitor[hostKey];

                              // if (key === 'o5') {
                              //   const o5 = exhibitor.o5_host_status;
                              //   const o6 = exhibitor.o6_host_status;

                              //   if (o5 === '申請しない' && (o6 === '未確認' || o6 === '確認済')) {
                              //     displayHostStatus = o6; // o6優先
                              //   } else if (o5 === '申請しない' && o6 === '申請しない') {
                              //     displayHostStatus = '申請しない';
                              //   } else {
                              //     displayHostStatus = o5; // それ以外はo5そのまま
                              //   }
                              // }

                              // candidates 作成
                              const candidates = [
                                exhibitor[exhibitorKey],
                                // displayHostStatus,
                                exhibitor[corporateKey],
                              ].filter(Boolean);

                              // STATUS_PRIORITY で currentStatus を決定
                              const STATUS_PRIORITY = [
                                '再提出',
                                '未提出',
                                '未確認',
                                '確認中',
                                '1のみ確認済',
                                '2のみ確認済',
                                '確認済',
                                '申請しない',
                              ];

                              let currentStatus = '未提出';
                              for (const status of STATUS_PRIORITY) {
                                if (candidates.includes(status)) {
                                  currentStatus = status;
                                  break;
                                }
                              }

                              const imgSrc = getStatusImage(currentStatus);
                              const checkboxId = `${exhibitor.exhibitor_id}_${key}`;

                              return (
                                <Box
                                  key={key}
                                  sx={{
                                    width: 110,
                                    borderRight: '1px solid #ccc',
                                    py: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                  }}
                                >
                                  {formattedDate && (
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        color: dateColor,
                                        textAlign: "center",
                                      }}
                                    >
                                      {formattedDate}
                                    </Typography>
                                  )}
                                  <img
                                    src={imgSrc}
                                    alt={`${label} ステータス`}
                                    className="max-61"
                                    onClick={
                                      currentStatus !== '申請しない' && !field.corporate
                                        ? () =>
                                            handleStatusClick(
                                              key,
                                              exhibitor.exhibitor_id,
                                              currentStatus,
                                              category
                                            )
                                        : field.corporate
                                        ? () => {
                                            setSelectedExhibitorId(exhibitor.exhibitor_id);
                                            setSelectedFormKey(key);
                                            setFormModalOpen(true);
                                          }
                                        : undefined
                                    }
                                    style={{
                                      cursor:
                                        currentStatus !== '申請しない' && !field.corporate
                                          ? 'pointer'
                                          : 'default',
                                      opacity: currentStatus === '申請しない' ? 0.6 : 1,
                                    }}
                                  />
                                  <input
                                    type="checkbox"
                                    checked={checkedPdfIds.includes(checkboxId)}
                                    onChange={() =>
                                      setCheckedPdfIds((prev) =>
                                        prev.includes(checkboxId)
                                          ? prev.filter((id) => id !== checkboxId)
                                          : [...prev, checkboxId]
                                      )
                                    }
                                    style={{ cursor: 'pointer' }}
                                  />
                                </Box>
                              );
                            })}

                            {/* モーダル */}
                            <Modal open={historyModalOpen} onClose={() => setHistoryModalOpen(false)}>
                              <Box
                                sx={{
                                  p: 4,
                                  backgroundColor: 'white',
                                  width: '95%',
                                  margin: 'auto',
                                  mt: 10,
                                  maxHeight: '90vh',
                                  overflowY: 'auto',
                                  position: 'relative'
                                }}
                              >
                                <IconButton
                                  onClick={() => setHistoryModalOpen(false)}
                                  sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                  }}
                                >
                                  <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                  変更履歴
                                </Typography>

                                {loadingHistory ? (
                                  <Typography>読み込み中...</Typography>
                                ) : historyLogs.length === 0 ? (
                                  <Typography>履歴なし</Typography>
                                ) : (
                                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                      <tr>
                                        <th>変更日時</th>
                                        <th>申請書</th>
                                        <th>変更前</th>
                                        <th>変更後</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {historyLogs.map((log) => {
                                        const isSameStatus = log.before_status === log.after_status;
                                        
                                        return (
                                        <tr key={log.log_id}>
                                          <td>{formatDateTime(log.changed_at)}</td>
                                          <td>
                                            {CATEGORY_MAP[log.submission_number] || `不明(${log.submission_number})`}
                                          </td>
                                          <td style={{ color: isSameStatus ? "red" : "inherit" }}>
                                            {log.before_status}
                                          </td>
                                          <td style={{ color: isSameStatus ? "red" : "inherit" }}>
                                            {log.after_status}
                                          </td>
                                        </tr>
                                      );})}
                                    </tbody>
                                  </table>
                                )}
                              </Box>
                            </Modal>

                           <Modal open={formModalOpen} onClose={() => setFormModalOpen(false)}>
                            <Box
                              sx={{
                                p: 4,
                                backgroundColor: 'white',
                                width: '95%',
                                margin: 'auto',
                                mt: 10,
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                position: 'relative'
                              }}
                            >
                              <IconButton
                                onClick={() => setFormModalOpen(false)}
                                sx={{
                                  position: 'absolute',
                                  top: 8,
                                  right: 8,
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                              {renderForm(selectedFormKey, selectedExhibitorId)}
                            </Box>
                          </Modal>

                          <Modal open={mypageModalOpen} onClose={() => setMypageModalOpen(false)}>
                            <Box
                              sx={{
                                p: 4,
                                backgroundColor: 'white',
                                width: '60%',
                                margin: 'auto',
                                mt: 10,
                                maxHeight: '80vh',
                                overflowY: 'auto',
                                borderRadius: 2,
                                position: 'relative'
                              }}
                            >
                              <IconButton
                                onClick={() => setMypageModalOpen(false)}
                                sx={{
                                  position: 'absolute',
                                  top: 8,
                                  right: 8,
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                              {mypageExhibitorId != null ? (
                                (() => {
                                  const target = exhibitors.find(ex => ex.exhibitor_id === mypageExhibitorId);
                                  if (!target) return <Typography>読み込み中...</Typography>;

                                  return (
                                    <Box>
                                      <Typography variant="h6" sx={{ mb: 2 }}>マイページ情報</Typography>
                                      <Typography>小間番号: {target.booth_number}</Typography>
                                      <Typography>会社名: {target.company_name}</Typography>
                                      <Typography>部署: {target.department}</Typography>
                                      <Typography>担当者名: {target.user_name}</Typography>
                                      <Typography>郵便番号: {target.zip_code}</Typography>
                                      <Typography>住所: {target.address}</Typography>
                                      <Typography>電話番号: {target.phone_number}</Typography>
                                      <Typography>メールアドレス: {target.email}</Typography>
                                    </Box>
                                  );
                                })()
                              ) : (
                                <Typography>読み込み中...</Typography>
                              )}
                            </Box>
                          </Modal>


                            {/* ダウンロード・アップロード・PDF（出展者用） */}
                            <Box
                                sx={{
                                  width: 180,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  py: 1,
                                }}
                              >
                                <img
                                  src={
                                    isConfirmed(exhibitor) && isConfirmedOp(exhibitor)
                                      ? '/excel-dl.png'
                                      : '/excel-dl-dis.png'
                                  }
                                  alt="Excelダウンロード"
                                  onClick={() => {
                                    if (isConfirmed(exhibitor) && isConfirmedOp(exhibitor)) {
                                      handleExcelDownload(exhibitor.exhibitor_id, exhibitor.company_name);
                                    }
                                  }}
                                  style={{
                                    cursor:
                                      isConfirmed(exhibitor) && isConfirmedOp(exhibitor) ? 'pointer' : 'not-allowed',
                                    opacity: isConfirmed(exhibitor) && isConfirmedOp(exhibitor) ? 1 : 0.5,
                                  }}
                                />

                                <img
                                  src={
                                    isConfirmed(exhibitor) && isConfirmedOp(exhibitor)
                                      ? '/excel-ul.png'
                                      : '/excel-ul-dis.png'
                                  }
                                  alt="Excelアップロード"
                                  onClick={() => {
                                    if (isConfirmed(exhibitor) && isConfirmedOp(exhibitor)) {
                                      triggerFileInput(exhibitor.exhibitor_id);
                                    }
                                  }}
                                  style={{
                                    cursor:
                                      isConfirmed(exhibitor) && isConfirmedOp(exhibitor) ? 'pointer' : 'not-allowed',
                                    opacity: isConfirmed(exhibitor) && isConfirmedOp(exhibitor) ? 1 : 0.5,
                                  }}
                                />

                                <input
                                  type="file"
                                  accept=".xlsx"
                                  style={{ display: 'none' }}
                                  ref={(el) => (fileInputsRef.current[exhibitor.exhibitor_id] = el)}
                                  onChange={(e) =>
                                    handleExcelUpload(exhibitor.exhibitor_id, e)
                                  }
                                />

                                <img
                                  src={canDownload(exhibitor) ? '/pdf-dl.png' : '/pdf-dl-dis.png'}
                                  alt="PDFダウンロード"
                                  title={canDownload(exhibitor) ? 'PDFをダウンロード' : 'PDF未生成 or 未確認'}
                                  onClick={() => {
                                    if (canDownload(exhibitor)) {
                                      handlePdfDownload(exhibitor.exhibitor_id, exhibitor.company_name);
                                    }
                                  }}
                                  style={{
                                    cursor: canDownload(exhibitor) ? 'pointer' : 'not-allowed',
                                    opacity: canDownload(exhibitor) ? 1 : 0.5,
                                  }}
                                />
                              </Box>
                          </Box>
                          </>
                        );
                      })}
                    </>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const newPage = Math.max(exhibitorPage - 1, 1);
                    setExhibitorPage(newPage);
                    setPageInput(newPage);
                  }}
                  disabled={exhibitorPage === 1}
                  sx={{ mx: 1 }}
                >
                  前へ
                </Button>
                <TextField
                  value={pageInput}
                  onChange={(e) => setPageInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handlePageChange();
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  size="small"
                  type="number"
                  sx={{ width: 80, mx: 1 }}
                  inputProps={{
                    min: 1,
                    max: exhibitorTotalPages
                  }}
                />

                <Typography sx={{ mx: 1 }}>
                  / {exhibitorTotalPages}
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => {
                    const newPage =
                      exhibitorPage < exhibitorTotalPages ? exhibitorPage + 1 : exhibitorPage;
                    setExhibitorPage(newPage);
                    setPageInput(newPage);
                  }}
                  disabled={exhibitorPage >= exhibitorTotalPages}
                  sx={{ mx: 1 }}
                >
                  次へ
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
        <footer>
          <Typography>
            © 2026 THE MID-JAPAN ECONOMIST.
          </Typography>
        </footer>
    </div>
  );
};

export default HostMypage;
